import {buildLocalRunLeftRecord, buildLocalRunProgress, buildLocalRunRecord} from '../../utils/localMatch/replay/localRunRecordRules';
import {selectGameResults, selectRound} from '../reducers/sharedStateReducer/selectors';

/**
 * Запись локального матча (движок записи общий с обучением, см.
 * createTutorialReplayRecorder; правила — localRunRecordRules).
 *
 * Стоит там же, где сетевая партия отдает действия серверу, — перед
 * networkMiddleware. Место в записи резервируется до применения экшена, а
 * заполняется после: к этому моменту известно, изменил ли он общее состояние,
 * а вложенные диспатчи (ходы ботов, модалки) уже легли в порядке применения.
 *
 * Отправка — НЕ по таймеру, а раз в раунд: локальных партий много, и на
 * каждое действие ходить на сервер незачем. Поводы отправить накопленное:
 *  - сменился раунд (отдельного экшена «начался раунд» в движке нет, поэтому
 *    сравниваем номер до и после применения);
 *  - подведены итоги партии (обычный конец и досрочный по отрыву в очках —
 *    там раунд не меняется);
 *  - выход из партии (RESET_STATE) и закрытие вкладки — это уже делает сам
 *    рекордер через endRun и подписку на pagehide.
 */
export const createLocalMatchReplayMiddleware = ({getRecorder, now = () => Date.now()}) => (store) => (next) => (action) => {
  const recorder = getRecorder();
  if (!recorder || !action || !recorder.isRecording()) {
    return next(action);
  }

  if (action.type === 'RESET_STATE') {
    const stateBefore = store.getState();
    recorder.setProgress(buildLocalRunProgress({round: selectRound(stateBefore)}));
    recorder.endRun(buildLocalRunLeftRecord({round: selectRound(stateBefore), recordedAt: now()}));
    return next(action);
  }

  const slot = recorder.reserveSlot();
  const recordedAt = now();
  const stateBefore = store.getState();
  const sharedBefore = stateBefore?.shared;
  const roundBefore = selectRound(stateBefore);
  const hasResultsBefore = (selectGameResults(stateBefore) || []).length > 0;
  try {
    return next(action);
  } finally {
    const stateAfter = store.getState();
    recorder.fillSlot(slot, buildLocalRunRecord(action, {
      isSharedStateChanged: stateAfter?.shared !== sharedBefore,
      recordedAt,
    }));
    const roundAfter = selectRound(stateAfter);
    recorder.setProgress(buildLocalRunProgress({round: roundAfter}));

    const hasResultsAfter = (selectGameResults(stateAfter) || []).length > 0;
    if (roundAfter !== roundBefore || (hasResultsAfter && !hasResultsBefore)) {
      recorder.flushNow();
    }
  }
};
